//import Products from './screens/index.vue';
const Products = () => import('./screens/index.vue')

import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

const productsRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.PRODUCT_VIEW,
    PERMISSIONS_KEYS.PRODUCT_INSERT,
    PERMISSIONS_KEYS.PRODUCT_EDIT,
    PERMISSIONS_KEYS.PRODUCT_DELETE,
  ])
) {
  productsRoutes.push({
    path: '/regras-da-prescricao/produtos',
    name: 'Cadastro / Consulta|Produto',
    component: Products,
    meta: {
      icon: 'fa-prescription-bottle',
      requiresAuth: true,
    },
  });
}

export { productsRoutes };
